import {
  cameraTypeList,
  keyProtectAdditionalEquipmentVulcan,
  keyProtectIncludedEquipmentCameraSelectionVulcan,
  secureBusinessOppositeSectionKeysVulcan,
  smartCameraAdditionalEquipmentVulcan,
  smartCameraIncludedEquipmentCameraSelectionVulcan
} from '../../../../utils/constant';

const replaceTheName = {
  [smartCameraIncludedEquipmentCameraSelectionVulcan]: smartCameraAdditionalEquipmentVulcan,
  [smartCameraAdditionalEquipmentVulcan]: smartCameraAdditionalEquipmentVulcan,
  [keyProtectAdditionalEquipmentVulcan]: keyProtectAdditionalEquipmentVulcan,
  [keyProtectIncludedEquipmentCameraSelectionVulcan]: keyProtectAdditionalEquipmentVulcan
};

/**
 * Syncs the video service charge option based on combined camera count across the current
 * section and its opposite section (per secureBusinessOppositeSectionKeysVulcan).
 * Only runs for smart camera / protect sections and when the changed field is a camera type.
 * If combined count < 5: hides videoServiceCharge and sets value to 0; if >= 5: shows it and sets value to 1.
 */
export const getTotalCamera = (
  opt,
  fieldProductType,
  fields,
  name,
  formFields,
  formObjectKeys
) => {
  const updateField = fields;
  if (
    [
      smartCameraIncludedEquipmentCameraSelectionVulcan,
      smartCameraAdditionalEquipmentVulcan,
      keyProtectAdditionalEquipmentVulcan,
      keyProtectIncludedEquipmentCameraSelectionVulcan
    ].includes(name) &&
    cameraTypeList.includes(fieldProductType)
  ) {
    const otherSectionKey = secureBusinessOppositeSectionKeysVulcan[name];
    const otherSection = { ...formFields[otherSectionKey] };
    const otherSectionSum = Object.keys(otherSection)
      .filter(ko =>
        cameraTypeList.includes((otherSection[ko] || {}).productType)
      )
      .reduce((acc, ko) => acc + parseInt(otherSection[ko].value || 0, 10), 0);
    const currentSum = formObjectKeys
      .filter(key => cameraTypeList.includes(opt[key].productType))
      .reduce((acc, key) => acc + parseInt(opt[key].value || 0, 10), 0);

    const targetSection = updateField[replaceTheName[name]];
    const videoServiceCharge = targetSection && targetSection.videoServiceCharge;

    if (videoServiceCharge) {
      if (otherSectionSum + currentSum < 5) {
        videoServiceCharge.isVisible = false;
        videoServiceCharge.value = 0;
      } else if (otherSectionSum + currentSum >= 5) {
        videoServiceCharge.isVisible = true;
        videoServiceCharge.value = 1;
      }
    }
  }
};
